import events from '../events';
import usersApiClient from '../login-register/UsersApiClient';
import breakpoints from '../utils/breakpoints';
import './cartModal.scss';
import './index.scss';
import { getCurrentUser } from "../utils/current-user";
export * from './cartModal';
export function modal() {
    return {
        modalOpen: false,
        showBackdrop: false,
        centeredFixed: false,
        error: [],
        init() {
            events.setBackdrop.subscribe((open) => {
                this.showBackdrop = open;
            });
            events.openLogin.subscribe(data => {
                var _a;
                if (breakpoints.isMobile()) {
                    const returnUrl = location.pathname + location.search;
                    location.replace(`/login?returnUrl=${encodeURIComponent(returnUrl)}`);
                    return;
                }
                this.modalOpen = data.open;
                this.centeredFixed = (_a = data.centeredFixed) !== null && _a !== void 0 ? _a : false;
            });
            window.addEventListener("resize", () => {
                if (breakpoints.isMobile()) {
                    this.modalOpen = false;
                }
            });
            try {
                const currentUser = getCurrentUser();
                events.onCartBadgeUpdate.trigger(currentUser.basketQuantity);
            }
            catch {
            }
            const queryStrings = new URLSearchParams(location.search);
            this.modalOpen = queryStrings.get("returnUrl") !== null && !breakpoints.isMobile();
        },
        openWithOptions(open, center) {
            this.modalOpen = open;
            this.centeredFixed = center;
        },
        logout() {
            usersApiClient.logout().then(() => location.reload());
        },
    };
}
